export default class MediaConstraints {
    constructor() {
        this.audio = false;
    }
    static userCameraConstraints() {
        const instance = new MediaConstraints();
        instance.video = new VideoConstraints();
        instance.video.facingMode = 'user';
        return instance;
    }
    static envCameraConstraints() {
        const instance = new MediaConstraints();
        instance.video = new VideoConstraints();
        instance.video.facingMode = 'environment';
        return instance;
    }
}
class VideoConstraints {
    switchFacingMode(tryAgain = false) {
        if (this.facingMode === 'user') {
            this.facingMode = 'environment';
        }
        else if (tryAgain) {
            console.log("SwitschFacingMode: TryAgain");
            this.facingMode = {
                exact: 'environment'
            };
        }
        else {
            this.facingMode = 'user';
        }
    }
}
